<ex-button
  size="medium"
  type="secondary"
  variant="raised"
  icon="download-simple"
  [disabled]="downloading"
  (click)="onExport()"
  class="export-button"
  data-cy="export-button"
  [ngbTooltip]="'common.export-tooltip' | translate"
  placement="bottom auto"
  tooltipClass="simple-tooltip fit"
  container="body"
  [openDelay]="500"
>
</ex-button>

<ng-template #exportInProgressToast let-toast="toast" let-toastService="toastService">
  <div class="awaiting-toast-container no-select" data-cy="export-status-toast">
    <div class="left-part d-flex">
      <div class="align-middle justify-content-center">
        <div class="waiting-circle-full"></div>
      </div>
    </div>
    <div class="center-part">
      <div class="title color-primary-500 fw-bold">
        <span class="d-table-cell align-middle">{{ 'export.awaiting-export-toast-title' | translate | uppercase }}</span>
      </div>
      <div class="text fst-italic fw-bold color-basic-800">
        <span class="d-table-cell align-middle">{{ 'export.awaiting-export-toast-text' | translate }}</span>
      </div>
      <div class="cancel-export color-basic-600 fw-bold d-table">
        <span class="d-table-cell align-middle" (click)="toastService.remove(toast); stopExportAndRemoveExportToast()">{{
          'export.awaiting-export-toast-cancel' | translate
        }}</span>
      </div>
    </div>
    <div class="right-part">
      <div class="hide-icon" ngbTooltip="{{ 'export.hide' | translate }}" placement="top">
        <mat-icon
          svgIcon="hide-600"
          class="icon-20 strict me-2"
          (click)="
            toastService.hide(
              toast,
              exportInProgressToast,
              'toast-export-in-progress toast-shape ' + ('t-e-i-p-' + document.id),
              document.id,
              lightToast
            )
          "
        >
        </mat-icon>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #lightToast let-toast="toast" let-toastService="toastService">
  <div class="mini-toast-container d-flex">
    <div class="separator"></div>
    <div class="mini-toast" (click)="toastService.unhide(toast, document.id)">
      <div class="mini-waiting-circle d-table-cell align-middle align-content-center">
        <div class="waiting-circle-mini"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #errorInExport>
  <app-toast-error [title]="'export.export-error-title'" [text]="'export.export-error-text'"> </app-toast-error>
</ng-template>
